import i18n from '@/plugins/i18n'

export interface IIllnessCategory {
  id: number;
  name: string;
  types: IIllnessType[];
}

export interface IIllnessType {
  id: number;
  name: string;
  illnesses: IIllnessItem[];
}

export interface IIllnessItem {
  id: number;
  name: string;
}

export interface IIllness {
  id?: number;
  player_id: number;
  title: string;
  date: string;
  illness_category_id: number;
  illness_type_id: number;
  illness_id: number;
  medicaments: string;
  recurrent: boolean;
  expected_rtc: string | null;
  note: string;
  media_ids: number[];
  still_active: boolean;
}

export enum IllnessPhase {
  ILLNESS = 'illness',
  CHECKUP = 'checkup',
  RETURN_COMPETITION = 'competition',
}

export const IllnessPhases = {
  [IllnessPhase.ILLNESS]: {
    get text() { return i18n.t('add_new.illness') }
  },
  [IllnessPhase.CHECKUP]: {
    get text() { return i18n.t('medical.checkup') }
  },
  [IllnessPhase.RETURN_COMPETITION]: {
    get text() { return i18n.t('injury_individual.status.return_to_competition') }
  }
}
